import { createFileRoute, Outlet, redirect, Navigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { Sidebar } from '@/components/layout/sidebar'
import { MobileNav } from '@/components/layout/mobile-nav'
import { useIsMobile } from '@/hooks/use-media-query'
import { useAuth } from '@/hooks/use-auth'
import { getMenuKeyFromPath } from '@/hooks/use-menu-access'
import { Loader2 } from 'lucide-react'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    console.log('[Route Guard] Checking access for:', location.pathname)

    // Espera o auth resolver antes de decidir
    const isAuthenticated = await context.auth.whenReady()
    console.log('[Route Guard] isAuthenticated:', isAuthenticated, 'role:', context.auth.role)

    if (!isAuthenticated) {
      console.log('[Route Guard] Not authenticated, redirecting to login')
      throw redirect({ to: '/login', search: { redirect: location.pathname } })
    }

    // Verifica acesso ao menu
    const menuKey = getMenuKeyFromPath(location.pathname)
    const hasAccess = context.auth.hasMenuAccess(menuKey)
    console.log('[Route Guard] menuKey:', menuKey, 'hasAccess:', hasAccess)

    if (!hasAccess) {
      console.log('[Route Guard] Access denied to', menuKey, '- redirecting to /home')
      toast.error('Voce nao tem acesso a esta pagina', {
        duration: 3000,
        dismissible: true,
      })
      throw redirect({ to: '/home' })
    }

    console.log('[Route Guard] Access granted to:', location.pathname)
  },
  component: AuthenticatedLayout,
})

// OTIMIZAÇÃO: Componente simplificado - beforeLoad já garante autenticação e acesso
function AuthenticatedLayout() {
  const isMobile = useIsMobile()
  const { isLoading, isAuthenticated } = useAuth()

  // Loading state apenas durante inicialização
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }

  // Fallback de segurança (não deveria acontecer após beforeLoad)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="min-h-screen bg-background">
      {!isMobile && <Sidebar />}
      <Outlet />
      {isMobile && <MobileNav />}
    </div>
  )
}
